var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from "react";
import { DataFormUsers } from "../constanst/adminUsersDTO";
export var useUserActions = function (_a) {
    var setDataFormUsers = _a.setDataFormUsers, setUserId = _a.setUserId, setIsEdit = _a.setIsEdit, setOpenModalAddNewUser = _a.setOpenModalAddNewUser, setUserName = _a.setUserName, setOpenDrawer = _a.setOpenDrawer, setRolesRows = _a.setRolesRows, setAssignedRoles = _a.setAssignedRoles;
    /**
     * Resetea el formulario al estado inicial preservando branch y company
     */
    var handleResetFormToInitialState = useCallback(function () {
        setDataFormUsers(function (prevState) { return (__assign(__assign({}, DataFormUsers), { branch: prevState.branch, company: prevState.company })); });
        setUserId("");
    }, [setDataFormUsers, setUserId]);
    var onOptionsCardClick = useCallback(function (opt, item) {
        var _a, _b;
        switch (opt.id) {
            case "1": // Editar usuario
                setUserId(item.id);
                setIsEdit(true);
                setOpenModalAddNewUser(true);
                setDataFormUsers(function (prevState) { return (__assign(__assign({}, prevState), { names: item.names || "", lastNames: item.lastNames || "", username: item.type || "", email: item.description || "", company: item.clientId || "", branch: item.branchId || "" })); });
                break;
            case "2": // Ver/Editar roles
                setUserId(item.id);
                setUserName(item.code);
                setOpenDrawer(true);
                // Mapear roles para la tabla
                var rows = ((_a = item.roles) === null || _a === void 0 ? void 0 : _a.map(function (role) {
                    var _a, _b, _c;
                    return ({
                        id: (_a = role === null || role === void 0 ? void 0 : role.id) !== null && _a !== void 0 ? _a : "",
                        rolName: (_b = role.name) !== null && _b !== void 0 ? _b : "",
                        description: (_c = role.description) !== null && _c !== void 0 ? _c : "",
                    });
                })) || [];
                setRolesRows(rows);
                // Mapear roles para asignación
                var rolesList = ((_b = item.roles) === null || _b === void 0 ? void 0 : _b.map(function (role) {
                    var _a, _b, _c;
                    return ({
                        id: (_a = role === null || role === void 0 ? void 0 : role.id) !== null && _a !== void 0 ? _a : "",
                        name: (_b = role.name) !== null && _b !== void 0 ? _b : "",
                        description: (_c = role.description) !== null && _c !== void 0 ? _c : "",
                    });
                })) || [];
                setAssignedRoles(rolesList);
                break;
        }
    }, [
        setUserId,
        setIsEdit,
        setOpenModalAddNewUser,
        setDataFormUsers,
        setUserName,
        setOpenDrawer,
        setRolesRows,
        setAssignedRoles,
    ]);
    return {
        handleResetFormToInitialState: handleResetFormToInitialState,
        onOptionsCardClick: onOptionsCardClick,
    };
};
